import compose from '@hypnosphi/recompose/compose';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

import { usePostmongerContext } from '../../contexts/PostmongerContext';


import Button from 'apollo-react/components/Button';


const styles = {
    paper: {
      maxWidth: 800,
      padding: 32,
      '& label': {
        marginBottom: 0,
      },
    },
    submit: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    section: {
      marginBottom: 32,
    },
  };

export const GenericButtons = ({ classes, onCancel, onDone, onNext, onPrevious, page, pageCount }) => {
    const { t } = useTranslation();

    const { 
        disabled, 
        noTopicAvailable,
      } = usePostmongerContext();    

    return (<>{disabled || noTopicAvailable ? (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {page >= pageCount && (
            <Button variant="primary" onClick={onCancel}>
            {t('generic.okButton')}
            </Button> 
          )}
          {page < pageCount && (
            <Button variant="primary" onClick={onNext}>
            {t('generic.nextButton')}
            </Button> 
          )}
        </div>
          ) : (
        <div className={classes.submit}>
          {page <= pageCount && (
            <Button className={classes.submitCancel} variant="secondary" onClick={onCancel} >
              {t('generic.cancelButton')}
            </Button>
          )}
          <span className={classes.submit}>
            {page > 1 && (
              <Button style={{ marginRight: '10px'}} variant="secondary" onClick={onPrevious} >
                {t('generic.previousButton')}
              </Button>
            )}
            {page < pageCount && (
              <Button variant="primary" onClick={onNext} >
                {t('generic.nextButton')}
              </Button>
            )}
            {page >= pageCount && (
              <Button variant="primary" onClick={onDone}>
                {t('generic.doneButton')}
              </Button>
            )} 
          </span>
        </div>
      )
    }</>);
}    

export default compose(
    withStyles(styles)
    )(GenericButtons);
  